import { getDocumentPageUrl } from './url-helpers';
import { getParamString } from './utils';
export function sharePublicationOnEmail(config, publication, pageNumber) {
    shareLinkOnEmail({
        url: getDocumentPageUrl({
            mainHost: config.hosts.main,
            username: publication.username,
            documentName: publication.name,
            pageNumber,
        }),
        title: 'I found this great publication on issuu.com',
    });
}
export function shareLinkOnEmail(link) {
    const body = `\
${'Check this out:'}

${link.url}\
    `;
    const params = {
        subject: link.title,
        body,
    };
    window.location.assign(`mailto:?${getParamString(params)}`);
}
//# sourceMappingURL=email.js.map